import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export default class FooterLogosSliders {
	
	constructor(el) {

		this.el = el;

		this.initFooterLogosSlidersSwipers(el);

	} 

	initFooterLogosSlidersSwipers(elm){		

		const swiper = new Swiper( elm.querySelector('.swiper'), {    
			modules           			: [ Pagination ],
			slidesPerView     			: 2,
			centeredSlides	  			: false,
			loop              			: false,			
			spaceBetween      			: 28,
			autoHeight        			: false,
			navigation        			: false, 
			centerInsufficientSlides 	: true,
			pagination        			: {
				el          : elm.querySelector('.swiper-pagination'),				
			},
			breakpoints       			: {
				10 : {
					slidesPerView   : 2,          
					spaceBetween    : 16,
			  	},
			  	320 : {
					slidesPerView   : 3,
					spaceBetween    : 10,
			  	}, 
			  	400 : {
					slidesPerView   : 3,
					spaceBetween    : 16,
			  	}, 
			  	480 : {
					slidesPerView   : 4,          
					spaceBetween    : 16,
				}, 
				640 : {
					slidesPerView   : 5,          
					spaceBetween    : 16,
			  	},  
			  	768 : {
					slidesPerView   : 6,          
					spaceBetween    : 16,
			  	},    
			  	1024 : { 
					slidesPerView   : 7,          
					spaceBetween    : 16,
			  	},    
			  	1240 : {
					slidesPerView   : 8,          
					spaceBetween    : 18,
			  	},          
			  	1420 : {
					slidesPerView   : 10,          
					spaceBetween    : 18,
			  	},          
			},
		});

	}

}